/* Push subscription helper — registers service worker and subscribes to Web Push. */
import { api } from "./api";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function registerPush() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    console.info("Push not supported in this browser");
    return;
  }
  try {
    const reg = await navigator.serviceWorker.register("/service-worker.js");
    await navigator.serviceWorker.ready;
    if (Notification.permission === "default") {
      const r = await Notification.requestPermission();
      if (r !== "granted") return;
    }
    if (Notification.permission !== "granted") return;
    const { data } = await api.get("/push/public-key");
    if (!data?.configured || !data?.vapid_public_key) {
      console.info("Push not configured on server");
      return;
    }
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.vapid_public_key),
      });
    }
    const json = sub.toJSON();
    await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
  } catch (e) {
    console.warn("Push registration failed", e);
  }
}
